import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class BudgetType extends Mappeable {

    idTypeStatusBudgetPk: number;
    txtTypeStatusBudget: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            txtTypeStatusBudget: this.txtTypeStatusBudget,
            mrkActive: this.mrkActive
        }
    }

}
